import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { InvoiceRequests } from "@/features/finance/modules/invoice-requests/invoice-requests";
import { InvoicesPage } from "@/features/finance/modules/invoices/invoices-page";
import { hasPermissionInList } from "@/features/navigation/filter-nav-entries";
import { m } from "@/paraglide/messages.js";
import { PermissionAction, PermissionSubject } from "@complete-athlete/enums";

const thisMonth = () => new Date().toISOString().slice(0, 7);

export const Route = createFileRoute("/(private)/finances/invoices/")({
  beforeLoad: async () => {
    const { data } = await sdk.users.me.$get.send();
    if (!hasPermissionInList(data?.permissions ?? null, PermissionAction.READ, PermissionSubject.FINANCE)) {
      throw redirect({ to: "/" });
    }
  },
  loader: () => ({ crumb: m.finance_invoices_title() }),
  validateSearch: z.object({ month: z.string().regex(/^\d{4}-\d{2}$/).optional().catch(undefined) }),
  component: InvoicesRoute,
});

function InvoicesRoute() {
  const { month } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <div className="grid gap-8">
      <InvoiceRequests />
      <InvoicesPage month={month ?? thisMonth()} onMonthChange={(next) => void navigate({ search: { month: next } })} />
    </div>
  );
}
